export default __webpack_public_path__ + "static/media/iconePessoaFisica2.4ff81692.png";